import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType, GaTrackingEventCategory, GaTrackingEventName } from '../../constants';
import { EventWithLabel } from '~shared/modules/seo/constants';

export class GATrackingContentCardClickEvent implements GATrackingEvent {
  constructor(private payload: EventWithLabel) {}

  getEventType(): any {
    return GATrackingEventType.ContentCardClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.ContentCardClick,
      label: this.payload.label,
      gtmCustom: {
        category: GaTrackingEventCategory.Interaction
      }
    };
  }
}
